export { default } from './pricing.view';
